export default __webpack_public_path__ + "static/media/title-tireOrderingIcon.7b571642.svg";